import React, {Fragment} from "react";
import {Menu, Transition} from "@headlessui/react";
import {ChevronDownIcon} from "@heroicons/react/solid";
import { DocumentSearchIcon, PencilAltIcon, BadgeCheckIcon } from "@heroicons/react/outline";
import {useTranslation} from "react-i18next";
import { TO_APPROVE, DRAFT, APPROVED } from "../../../constants/config";
import Loader from "../loader/loader";





function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const ProductStatusList = ({isLoading, status, onChangeStatus, isEditable = true}) => {
    const { t } = useTranslation();

    let statusStyles = {
        draft: {
            style: isEditable ? 'border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white' : 'border-gray-800 text-gray-800',
            title: t("app.catalog.status_draft"),
            icon: PencilAltIcon
        },
        to_approve: {
            style: isEditable ? 'border-yellow-700 text-yellow-700 hover:bg-yellow-700 hover:text-white' : 'border-yellow-700 text-yellow-700',
            title: t("app.catalog.status_to_approve"),
            icon: DocumentSearchIcon
        },
        approved: {
            style: isEditable ? 'border-green-800 text-green-800 hover:bg-green-800 hover:text-white' : 'border-green-800 text-green-800',
            title: t("app.catalog.status_approved"),
            icon: BadgeCheckIcon
        }
    };
    

    const getStatus = () => {
        let list = [];

        if (status === DRAFT) {
            list = [TO_APPROVE, APPROVED]
        }

        if (status === TO_APPROVE) {
            list = [DRAFT, APPROVED]
        }
        if (status === APPROVED) {
            list = [DRAFT, TO_APPROVE]
        }
      

        return list;
    }

    const IconList = ({status, className}) => {

        let IconType = statusStyles[status].icon;
        return (
            <IconType
                className={className}
                aria-hidden="true"
            />
        )
    }

    return (
        <Menu as="div" className="relative inline-block text-left ">
            <div>
                <Menu.Button className={classNames(
                    "btn rounded-0",
                    statusStyles[status].style,
                )}
                >

                    {
                        isLoading ? (
                            <div className="mr-6">
                                <Loader />
                            </div>
                        ) : (
                            <IconList
                                status={status}
                                className={classNames(
                                    "w-4 h-4 mr-1 flex-shrink-0"
                                )}
                            />
                        )
                    }



                    {statusStyles[status].title}

                    {
                        isEditable && (
                            <ChevronDownIcon className="w-5 h-5 ml-4 -mr-1 text-current" aria-hidden="true"/>
                        )
                    }
                </Menu.Button>
            </div>

            {
                isEditable && (
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute right-0 w-56 mt-2 origin-top-right bg-solitude-200 divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">


                            {
                                getStatus().map((item) => (
                                    <Menu.Item key={item}>
                                        {({ active }) => (
                                            <div
                                                onClick={(() => {
                                                    onChangeStatus(item)
                                                })}
                                                className={
                                                    classNames(
                                                        active || false ? 'bg-indigo-800 text-solitude-200' : 'bg-solitude-200',
                                                        statusStyles[item].style,
                                                        'group flex  items-center w-full p-3 text-sm cursor-pointer'
                                                    )}
                                            >
                                                <IconList
                                                    status={item}
                                                    className={classNames(
                                                        'w-5 h-5 mr-2'
                                                    )}
                                                />
                                                {statusStyles[item].title}
                                            </div>
                                        )}
                                    </Menu.Item>
                                ))
                            }




                        </Menu.Items>
                    </Transition>
                )
            }


        </Menu>
    );
};
